import React, {Component} from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import Icon from "../../../../icon";
import HorizontalChartToolTip from "./custom-tooltip/horizontal-chart-tooltip.component";
import Translation from "../../../../common/translation/translation.component";
import Moment from 'moment';

class UsageHorizontalChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    componentDidMount() {
        this.props.setRef(this.chartRef);
    }

    DetailsInfo() {
       
        if(this.props.printData)
        {
            return (
                <div className="usage-graph-title-container breakdown-container">   
                    <h1>{`Breakdown of Usage for the ${this.props.dateCurrentMonth.Date ? this.props.dateCurrentMonth.Date : ""}`}</h1>                       
                </div>
            )
        } else{
            return (
                <div className="usage-graph-title-container">
                    <h1>Breakdown of Usage for the {Moment.utc(this.props.dateCurrentMonth.Date).format('MMMM yyyy')}</h1>
                    <div className="details-info-breakdown">
                        <Icon
                            customClassName="icon-info-circle icon-info-header icon-info-alingment "
                            name="info-circle-solid"
                            size="15px"
                        />
                        <div className="details-list">
                            <span><Translation translationKey={"inventory_breakdown_tooltip"} /></span>
                        </div>
                    </div>
                </div>
            )
        };   
    }

    render() {
       
        return (
            <div className="usage-line-chart-main">
                <div className="usage-line-chart-container">  
                    
                    {this.props.data.length > 0 ?
                        <div className="breakdown-main-container">                    
                            <div ref={this.chartRef}>                       
                                <div className="details-info">{this.DetailsInfo()}</div>
                                <br></br>
                                <br></br>
                            <div className="chart-container">
                                <ResponsiveContainer width={1100} height={400} marginTop='10'> 
                                    <BarChart width={1500} data={this.props.data} layout="vertical" fill="#0071cc">
                                        <XAxis axisLine={false} tickLine={false} type="number" color='#15181b' fontSize={12} fontWeight='normal'/> 
                                        <YAxis width={100} tickLine={false} dataKey="name" type="category" fontFamily="Graphik-Regular" fontWeight="normal" axisLine={false} tick={{fontSize: 12, fill: '#919eab'}} paddingBottom={20}/>
                                        <Tooltip content={<HorizontalChartToolTip />} />
                                        <CartesianGrid horizontal={false}/>    
                                        <Bar dataKey="usage" fill={this.props.fill} barSize={50} radius={[0, 10, 10, 0]} />          
                                    </BarChart> 
                                </ResponsiveContainer>
                            </div>
                        </div>
                        </div>
                        :
                        <div className="details-info">{this.DetailsInfo()}
                                <br></br>
                                <br></br>
                         <h4 className="table-no-results"><Translation translationKey="no_data_retrieved" /></h4>
                        </div>
                     }
                </div>
            </div>
        )
    }
}

export default UsageHorizontalChart
